import { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, X } from 'lucide-react';
import { AuthContext } from '../../contexts/AuthContext';
import { hasRealEmail } from '../../utils/accountStatus';

const DISMISS_KEY = 'missingEmailBannerDismissed';

const MissingEmailBanner = () => {
  const { currentUser, userProfile, profileLoading } = useContext(AuthContext);
  const location = useLocation();
  const [dismissed, setDismissed] = useState(
    () => typeof window !== 'undefined' && sessionStorage.getItem(DISMISS_KEY) === '1'
  );

  if (!currentUser || profileLoading || dismissed) return null;
  if (hasRealEmail(userProfile, currentUser)) return null;
  if (location.pathname === '/settings') return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="border-b border-warning/40 bg-warning/10 text-warning-foreground">
      <div className="mx-auto flex max-w-screen-2xl items-center gap-3 px-4 py-2 text-sm sm:px-6">
        <Mail className="h-4 w-4 shrink-0 text-warning" />
        <p className="flex-1">
          <span className="font-medium">Add your email address.</span>{' '}
          <span className="text-muted-foreground">
            Username-only accounts are being phased out. Add an email so you don't lose access.
          </span>
        </p>
        <Link
          to="/settings"
          className="shrink-0 rounded-md border border-warning/60 px-3 py-1 text-xs font-medium uppercase tracking-[0.15em] text-foreground transition-colors hover:bg-warning/20"
        >
          Update account
        </Link>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss"
          className="shrink-0 rounded-md p-1 text-muted-foreground transition-colors hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default MissingEmailBanner;
